<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="primary" @click="add">新增</Button>
    </div>
    <Table :datas="categoryList" :border="true" :loading="loading">
      <TableItem title="分类名称" prop="name"></TableItem>
      <TableItem title="收支方向" :width="100" align="center">
        <template slot-scope="{data}">
          {{ data.direction === 1 ? '收入' : '支出' }}
        </template>
      </TableItem>
      <TableItem title="对应科目">
        <template slot-scope="{data}">
          {{ subjectName(data.subjectId) }}
        </template>
      </TableItem>
      <TableItem title="操作" width="140">
        <div class="actions" slot-scope="{data}">
          <span @click="edit(data)">编辑</span>
          <span @click="remove(data)">删除</span>
        </div>
      </TableItem>
    </Table>
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">收支分类</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="分类名称" prop="name">
          <input type="text" v-model="form.name">
        </FormItem>
        <FormItem label="收支方向" prop="direction">
          <Select v-model="form.direction" :datas="directionList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="对应科目" prop="subjectId">
          <Select v-model="form.subjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const emptyForm = {
  name: '',
  direction: 2,
  subjectId: null
};

export default {
  name: "FundsCategory",
  data() {
    return {
      categoryList: [],
      subjectList: [],
      directionList: [{id: 1, name: '收入'}, {id: 2, name: '支出'}],
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['name', 'direction']
      },
      showForm: false,
      loading: false
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      Promise.all([
        this.$api.funds.category.list(),
        this.$api.setting.subject.voucherSelect({})
      ]).then((results) => {
        this.categoryList = results[0].data || [];
        this.subjectList = results[1].data || [];
      }).finally(() => this.loading = false);
    },
    subjectName(subjectId) {
      if (!subjectId) {
        return '-';
      }
      let subject = this.subjectList.find(val => val.id === subjectId);
      return subject ? `${subject.code}-${subject.name}` : '-';
    },
    add() {
      this.form = Object.assign({}, emptyForm);
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.$api.funds.category[this.form.id ? 'update' : 'save'](this.form).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.funds.category.delete(data.id).then(() => {
          this.loadList();
        })
      })
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>
